import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { Card } from "../../theme/components/index.js";
import { colorsSemantic } from "../../theme/tokens/colors-semantic.js";

/**
 * "Offene Schäden" — how the open workload splits by who has to act next.
 *
 * Bars are scaled against the largest group, not the total, so the shape of the
 * split stays readable even when one group dominates. Clicking a row filters the
 * board.
 */
export default function WaitingSplitCard({ rows = [], total = 0, onSelect }) {
  const { attention } = colorsSemantic;
  const max = Math.max(1, ...rows.map((row) => row.count ?? 0));

  return (
    <Card variant="surface" sx={{ padding: "15px 17px" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "baseline",
          justifyContent: "space-between",
          gap: "8px",
          mb: "12px",
        }}
      >
        <Typography
          sx={{ fontSize: "13.5px", fontWeight: 700, color: colorsSemantic.text.strong, letterSpacing: "-.1px" }}
        >
          Offene Schäden
        </Typography>
        <Typography sx={{ fontSize: "11.5px", color: colorsSemantic.text.muted }}>
          {`${total} gesamt`}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: "11px" }}>
        {rows.map((row) => {
          const color = attention.waiting[row.key] ?? attention.waiting.makler;
          const count = row.count ?? 0;

          return (
            <Box key={row.key} onClick={() => onSelect(row.key)} sx={{ cursor: "pointer" }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: "8px", mb: "5px" }}>
                <Box
                  component="span"
                  sx={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: color, flex: "none" }}
                />
                <Typography sx={{ fontSize: "12.5px", color: colorsSemantic.text.mutedStrong, flex: 1 }}>
                  {row.label}
                </Typography>
                <Typography sx={{ fontSize: "13px", fontWeight: 700 }}>{count}</Typography>
              </Box>
              <Box
                sx={{
                  height: "5px",
                  borderRadius: "3px",
                  backgroundColor: attention.track,
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    width: `${Math.round((count / max) * 100)}%`,
                    height: "100%",
                    borderRadius: "3px",
                    backgroundColor: color,
                    transition: "width .3s ease",
                  }}
                />
              </Box>
            </Box>
          );
        })}
      </Box>
    </Card>
  );
}

WaitingSplitCard.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({ key: PropTypes.string, label: PropTypes.string, count: PropTypes.number })
  ),
  total: PropTypes.number,
  onSelect: PropTypes.func.isRequired,
};
